"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Button, Logo } from "@/src/components";
import { Topbar } from "@/src/components/navigation/topbar";
import { Bell, Settings } from "lucide-react";

export default function DocsBlocksTopbar() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Topbar
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A header bar component with optional search, tabs, and custom right-side actions.
          </Text>
        </div>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Topbar with logo and actions</CardDescription>
            </>
          }
          contentClassName="p-0"
        >
          <div className="border-b">
            <Topbar
              logo={<Logo size={24} />}
              title="Dashboard"
              showSearch={false}
              rightItems={[
                <Button key="bell" variant="text" size="icon">
                  <Bell className="h-4 w-4" />
                </Button>,
                <Button key="settings" variant="text" size="icon">
                  <Settings className="h-4 w-4" />
                </Button>,
              ]}
            />
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">logo</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode</td>
                <td className="py-2 text-muted-foreground">Logo element</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">title</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode</td>
                <td className="py-2 text-muted-foreground">App or page title</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">showSearch</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">boolean</td>
                <td className="py-2 text-muted-foreground">Show search input</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">tabs</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">TopbarTab[]</td>
                <td className="py-2 text-muted-foreground">Navigation tabs</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">rightItems</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode[]</td>
                <td className="py-2 text-muted-foreground">Right-side action elements</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
